import { ApolloClient, HttpLink, InMemoryCache, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { onError } from "@apollo/client/link/error";
import { WebSocketLink } from "@apollo/client/link/ws";
import { Observable, getMainDefinition } from "@apollo/client/utilities";
import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { getToken } from "./hooks";

const authLink = setContext((_, { headers }) => {
    const token = getToken();
    return {
        headers: {
            ...headers,
            authorization: `Bearer ${token}`,
            "x-sigal-platform": "WEB"
        }
    };
});

const cache = new InMemoryCache();

console.log("API_URL", process.env.REACT_APP_API_URL);
console.log("WS_URL", process.env.REACT_APP_WS_URL);

const httpLink = new HttpLink({
    uri: process.env.REACT_APP_API_URL
});

const wsClient = new SubscriptionClient(process.env.REACT_APP_WS_URL, {
    reconnect: true,
    lazy: true,
    timeout: 10000,
    connectionParams: () => {
        return {
            authorization: `Bearer ${getToken()}`
        };
    }
});

const wsLink = new WebSocketLink(wsClient);

// setInterval(() => {
//   // if (!wsClient?.client) {
//   // @ts-ignore
//   wsClient.tryReconnect();
//   // }
// }, 10000);
// @ts-ignore
wsClient.maxConnectTimeGenerator.duration = () =>
// @ts-ignore
    wsClient.maxConnectTimeGenerator.max;

// @ts-ignore
window.wsClient = wsClient;

export const useAppApolloClient = () => {
    const toast = useToast();
    // const [wsStatus, setWsStatus] = useState("disconnected");

    // wsClient.onConnected(() => {
    //   setWsStatus("connected");
    // });

    // wsClient.onReconnected(() => {
    //   setWsStatus("reconnected");
    // });

    // wsClient.onError(() => {
    //   setWsStatus("error");
    // });

    // wsClient.onDisconnected(() => {
    //   setWsStatus("disconnected");
    // });

    // wsClient.onConnecting(() => {
    //   setWsStatus("connecting");
    // });

    // wsClient.onReconnecting(() => {
    //   setWsStatus("reconnecting");
    // });

    const errorLink = onError(
        ({ graphQLErrors, networkError, operation, forward }) => {
            if (graphQLErrors) {
                graphQLErrors.forEach(({ message }) => {
                    toast({
                        title: "Gabim",
                        description: message,
                        status: "error"
                    });
                    return Observable.of(operation);
                });
            }
            if (networkError) {
                return Observable.of(operation);
            }
            return forward(operation);
        }
    );

    const link = split(
        ({ query }) => {
            const definition = getMainDefinition(query);
            return (
                definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
            );
        },
        authLink.concat(wsLink),
        authLink.concat(errorLink).concat(httpLink)
    );

    const client = new ApolloClient({
        link,
        cache
    });

    return { client, wsStatus: "" };
};
